/**
 * @generated SignedSource<<18e6e95388c4a7a5f52ba7a41d0f67a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionProblemEventUpsertDialog_promotion$data = {
  readonly id: string;
  readonly nextOccurrences: ReadonlyArray<any>;
  readonly problemEvent: {
    readonly count: number;
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
  } | null;
  readonly startAt: any;
  readonly " $fragmentType": "PromotionProblemEventUpsertDialog_promotion";
};
export type PromotionProblemEventUpsertDialog_promotion$key = {
  readonly " $data"?: PromotionProblemEventUpsertDialog_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionProblemEventUpsertDialog_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionProblemEventUpsertDialog_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "kind": "ScalarField",
      "name": "nextOccurrences",
      "storageKey": "nextOccurrences(limit:1)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionProblemEvent",
      "kind": "LinkedField",
      "name": "problemEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationHours",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offsetHours",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "45ed4cbd01c7a15956a5052f3eb602d3";

export default node;
